import type { RouteRecordRaw } from "vue-router";
export const BusinessIntelligenceRoutes: RouteRecordRaw[] = [
    {
        path: '',
        name: 'businessIntelligencesList',
        component: () => import('./components/ListBusinessIntelligence.vue')
    },
    {
        path: ':id',
        name: 'businessIntelligencesView',
        component: () => import('./components/ViewBusinessIntelligence.vue')
    }
]